import ApplicationDetailsModal from './ApplicationDetailsModal'

export default ApplicationDetailsModal